export default __webpack_public_path__ + "static/media/lampuBelajar.61ce9edf.png";